/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const GreaterThanOrEqualRevision: core.serialization.ObjectSchema<
    serializers.GreaterThanOrEqualRevision.Raw,
    Truvity.GreaterThanOrEqualRevision
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace GreaterThanOrEqualRevision {
    export interface Raw {
        value: number;
    }
}
